import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PlayerTable from '../components/PlayerTable';
import { API_ENDPOINTS } from '../config/api';

const PlayersPage = () => {
    return (
        <Container maxWidth="xl">
            <Box sx={{ my: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom>
                    Active Players
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    View current player information including TPE, team assignments, and basic details.
                </Typography>
                <PlayerTable apiUrl={API_ENDPOINTS.ACTIVE_PLAYERS} />
            </Box>
        </Container>
    );
};

export default PlayersPage;